import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Match } from '../_shared/models/match.model';

interface substitutionObs {
    match: Match,
    success: boolean,
    message: string
}

@Injectable({
  providedIn: 'root'
})
export class ManageSubstitutionService {

   constructor(private http: HttpClient) { }

       // Add Substitution
        add(matchId: string, substitutionPolicy: any): Observable<substitutionObs> {
          return this.http
            .patch<any>('api_endpoint' + `/match/${matchId}/substitution-policy`, { substitutionPolicy }) 
        }

        // Remove Substitution
        remove(matchId: number): Observable<substitutionObs> {
          return this.http
            .delete<any>('api_endpoint' + `/match/${matchId}/substitution-policy`,)
        }
}
